import useBedbankRates from 'hooks/useBedbankRates'
import { useMemo } from 'react'

export default function useSearchTileBedbankRate(
  metaData: App.OfferListMetaData | undefined,
  filters?: App.OfferListFilters,
) {
  const isBedbankRate = metaData?.pricing?.rateType === 'bedbank'

  const [{ hotelOnlyRates: bedbankRates }, isFetchingBedbankRates] = useBedbankRates(
    isBedbankRate ? metaData?.pricing.ratePropertyId : undefined,
    filters?.rooms,
    filters?.checkIn,
    filters?.checkOut,
    isBedbankRate,
  )

  const bedbankRateForRoom = useMemo(() => {
    if (!isBedbankRate) return undefined
    const roomId = metaData?.pricing.roomId
    if (!roomId || !bedbankRates.length) return undefined

    return bedbankRates.find(rate => rate.roomId === roomId)
  }, [isBedbankRate, metaData?.pricing.roomId, bedbankRates])

  return {
    isBedbankRate,
    bedbankRateForRoom,
    isFetchingBedbankRates,
  }
}
